module.exports = {
	"id": "DO",
	"name": "Dominican Republic",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.038458,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.010988,
			"19": null,
			"20": null,
			"21": 0.016482,
			"22": 0.032964,
			"23": null,
			"24": null,
			"25": 0.005494,
			"26": 0.010988,
			"27": 0.010988,
			"28": 0.010988,
			"29": 0.032964,
			"30": 0.005494,
			"31": 0.043952,
			"32": 0.005494,
			"33": 0.010988,
			"34": 0.02747,
			"35": 0.016482,
			"36": 0.021976,
			"37": 0.02747,
			"38": 0.032964,
			"39": 0.076916,
			"40": 0.032964,
			"41": 0.021976,
			"42": 0.038458,
			"43": 0.225254,
			"44": 0.076916,
			"45": 0.043952,
			"46": 0.08241,
			"47": 0.115374,
			"48": 0.093398,
			"49": 2.933796,
			"50": 0.241736,
			"51": 1.351524,
			"52": 0.653786,
			"53": 25.673462,
			"54": 7.235598,
			"55": 0.05494,
			"56": 0.010988,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.016482,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.005494,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.010988,
			"32": 0.010988,
			"33": 0.005494,
			"34": null,
			"35": 0.021976,
			"36": 0.005494,
			"37": 0.010988,
			"38": 0.043952,
			"39": 0.021976,
			"40": 0.010988,
			"41": 0.016482,
			"42": 0.016482,
			"43": 0.126362,
			"44": 0.038458,
			"45": 0.131856,
			"46": 0.104386,
			"47": 0.538412,
			"48": 0.346122,
			"49": 2.944784,
			"50": 0.02747,
			"51": 0.005494,
			"52": null,
			"3.5": 0.005494,
			"3.6": 0.010988
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.010988,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.02747,
			"35": null,
			"36": 0.032964,
			"37": 0.043952,
			"38": 0.16482,
			"39": 0.016482,
			"40": 0.417544,
			"41": 0.060434,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.005494
		},
		"safari": {
			"0": null,
			"4": 0.021976,
			"5": 0.032964,
			"6": 0.005494,
			"7": 0.016482,
			"8": 0.142844,
			"9": 0.208772,
			"10": 0.955956,
			"3.1": null,
			"3.2": null,
			"5.1": 0.049446,
			"6.1": 0.032964,
			"7.1": 0.010988,
			"9.1": 0.736196
		},
		"ios_saf": {
			"8": 0,
			"10": 4.08663516653,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.110130088988,
			"8.1-8.4": 0.203460672877,
			"9.0-9.2": 0.097063807244,
			"9.3": 1.48084526436
		},
		"android": {
			"3": 0,
			"4": 0.101123863049,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0126404828811,
			"4.1": 0.364768220284,
			"4.2-4.3": 0.911920550711,
			"4.4": 2.09109702519,
			"4.4.3-4.4.4": 2.10915485788
		},
		"ie": {
			"6": 0.0183559224806,
			"7": 0.00611864082687,
			"8": 0.48949126615,
			"9": 0.177440583979,
			"10": 0.220271069767,
			"11": 1.4562365168,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0521936884188,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0014498246783
		},
		"edge": {
			"12": 0.08241,
			"13": 0.307664,
			"14": 0.527424
		},
		"ie_mob": {
			"10": 0.111927042254,
			"11": 0.455702957746
		},
		"bb": {
			"7": 0.08109,
			"10": null
		},
		"samsung": {
			"0": 2.302055
		},
		"and_uc": {
			"0": 0.265795
		},
		"op_mini": {
			"0": 0.703196486903
		},
		"and_chr": {
			"0": 32.753174
		},
		"and_ff": {
			"0": 0.01802
		}
	},
	"total": 98.396748
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/DO.json
 ** module id = 510
 ** module chunks = 0
 **/